import React from 'react';
import { Button, Modal } from 'react-bootstrap';
// import { propTypes } from 'react-bootstrap/esm/Image';
import { useDispatch, useSelector } from "react-redux";
import { setDialog } from "../../store/api/GetAllProduct";
import { ExclamationTriangleFill as Alert, Check, DashCircleFill as Cancel } from "react-bootstrap-icons";
const ModalDialog = () => {
    const openDialog = useSelector(state => state.popup?.openDialog);
    const arrayBtn = openDialog.arrayBtn;
    const dispatch = useDispatch();
    const handleModal = () => {
        if (openDialog.okOperation !== undefined) {
            {
                dispatch(openDialog.okOperation);
            }
        }
        dispatch(setDialog({ status: 'hide' }));
    }


    return (
        <Modal show={openDialog.status === 'show'} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle' style={{ display: 'inline-block', color: 'white', padding: '0.6rem 0.6rem' }}><Alert size={22} style={{ color: 'rgb(255 178 4)' }} />&nbsp;&nbsp;{openDialog.dialogTitle}</Modal.Header>
            <Modal.Body className='bodyStyle'>
                <span>{openDialog.dialogText}</span>
                <hr />
                {arrayBtn && arrayBtn.includes("yes") && <Button className='group-Btn' variant='info' onClick={handleModal}><Check size={18} />بله</Button>}
                {arrayBtn && arrayBtn.includes("no") && <Button className='group-Btn' variant='danger' onClick={() => dispatch(setDialog({ status: 'hide' }))}><Cancel size={18} /> &nbsp;خیر</Button>}
                {arrayBtn && arrayBtn.includes("ok") && <Button className='group-Btn' onClick={() => handleModal()}>متوجه شدم</Button>}
            </Modal.Body>
        </Modal>
    )
}
export default ModalDialog;